import * as types from './../constants/actionTypes';
import initialState from './initialState';

export default function (state = initialState.featureClasses, action) {
   switch (action.type) {
      case types.LOAD_FEATURE_CLASSES_SUCCESS : {
         return action.payload.featureClasses;
      }

      case types.SAVE_NEW_FEATURE_CLASS_SUCCESS: {
         return [].concat(state, action.payload.featureClass);
      }

      case types.SAVE_NEW_FEATURE_SUCCESS: {
         const featureClassIndex = state.findIndex((fClass) => {
            return fClass.id === action.payload.featureClassId;
         });
         return [
            ...state.slice(0, featureClassIndex),
            Object.assign({}, state[featureClassIndex], {
               features: [].concat(
                  state[featureClassIndex].features
                     ? state[featureClassIndex].features : [],
                  action.payload.feature)
            }),
            ...
               state.slice(featureClassIndex + 1)
         ];
      }

      default:
         return state;
   }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/featureClassReducers.js
 **/